import fetch from './fetch'


export function login(params) {
    return fetch({
        url: '/pc/user/login.do',
        method: 'get',
        params,
    })
}

export function activity(params) {
    return fetch({
        url: '/pc/qxsq/activity/list.do',
        method: 'get',
        params,
    })
}

export function permissionApplication(params) {
    return fetch({
        url: '/pc/qxsq/activity/apply.do',
        method: 'post',
        data: params
    })
}

export function getAdmin(params) {
    return fetch({
        url: '/pc/qxsq/activity/allStatus.do',
        method: 'get',
        params
    })
}

export function postAdmin(params) {
    return fetch({
        url: '/pc/qxsq/activity/applyAll.do',
        method: 'post',
        params
    })
}
export function approval(params) {
    return fetch({
        url: '/pc/qxsq/activity/resultList.do',
        method: 'get',
        params
    })
}
export function getactivity(params) {
    return fetch({
        url: '/pc/qxsq/activity/signUpList.do',
        method: 'get',
        params
    })
}
export function activityExport(params) {
    return fetch({
        url: '/pc/qxsq/activity/export.do',
        method: 'get',
        params
    })
}

export function adminActivity(params) {
    return fetch({
        url: '/pc/qxsq/activity/listByAdmin.do',
        method: 'get',
        params
    })
}

export function adminActivityInfo(params) {
    return fetch({
        url: '/pc/qxsq/activity/dataListByAdmin.do',
        method: 'get',
        params
    })
}

export function adminExport(params) {
    return fetch({
        url: '/pc/qxsq/activity/exportByAdmin.do',
        method: 'get',
        params
    })
}

export function dcActivityList(params) {
    return fetch({
        url: '/pc/qxsq/activity/dcActivityList.do',
        method: 'get',
        params
    })
}

export function sinobaseExportZb(params) {
    return fetch({
        url: '/sinobase/exportZb',
        method: 'get',
        params
    })
}

export function sinobasezbList(params) {
    return fetch({
        url: '/sinobase/zbList',
        method: 'get',
        params
    })
}
// IPA直播数据的查看列表
export function IPAExportzbList(params) {
    return fetch({
        url: '/ipa/export/zb/list',
        method: 'get',
        params
    })
}
// 获取当前所有BI报表
export function getBiReport(params) {
    return fetch({
        url: 'front/util/getBiReport',
        method: 'get',
        params
    })
}
// 删除某一个BI报表
export function deleteBiReport(params) {
    return fetch({
        url: '/front/util/deleteBiReport',
        method: 'POST',
        params
    })
}
// 获取当前所有BI报表
export function getBiReportDetail(params) {
    return fetch({
        url: '/front/util/getBiReportDetail',
        method: 'get',
        params,
    })
}
// 查看报表
export function getCustomerDetail(params) {
    return fetch({
        url: '/customer/form/reportList',
        method: 'get',
        params,
    })
}
// 查看报表
export function getIPAactivityList(params) {
    return fetch({
        url: '/ipa/other/activityList',
        method: 'get',
        params,
    })
}
// 导出报表
export function getCustomerExport(params) {
    return fetch({
        url: '/customer/form/export',
        method: 'get',
        params,
    })
}

// 查询Azure登录信息
export function getAzure(params) {
    return fetch({
        url: '/sso/user',
        method: 'get',
        params
    })
}


//////////////////
// WEBPACK FOOTER
// ./api/index.js
// module id = null
// module chunks = 